import React from 'react';
import { createRoot } from 'react-dom/client';
import { registerDynamicBootstrap } from '../../shared/registerDynamicBootstrap';
import { getAccountFrontData } from '../frontData';
import type { OrdersMountConfig } from './types';
import { useOrdersList } from './useOrdersList';
import './orders.css';

const mountSelector = '#ips-react-orders-root';

const readConfig = (mount: HTMLElement): OrdersMountConfig => {
  const frontData = getAccountFrontData();
  const ordersData = frontData.orders || {};

  const fallbackRestUrl = typeof frontData.restUrl === 'string' ? frontData.restUrl : '/wp-json/';
  const fallbackEndpoint = `${String(fallbackRestUrl).replace(/\/+$/, '')}/ips-order-account/v1/ips_get_orderlist`;

  return {
    endpoint: mount.dataset.endpoint || ordersData.sectionEndpoint || fallbackEndpoint,
    nonce: mount.dataset.nonce || (typeof frontData.restNonce === 'string' ? frontData.restNonce : ''),
    endpointSlug: mount.dataset.endpointSlug || ordersData.endpointSlug || 'orders',
    overlayId: mount.dataset.overlayId || 'ips-order-date-overlay',
  };
};

const bootstrap = () => {
  const mount = document.querySelector<HTMLElement>(mountSelector);
  if (!mount || mount.dataset.ipsReactMounted === '1') {
    return;
  }

  const config = readConfig(mount);
  if (!config.endpoint || !config.nonce) {
    return;
  }

  mount.dataset.ipsReactMounted = '1';

  const root = createRoot(mount);

  const App: React.FC = () => {
    useOrdersList(config);
    return null;
  };

  root.render(<App />);
};

registerDynamicBootstrap(bootstrap);
